import * as React from "react";
import { Link } from "react-router-dom";

import BackButton from "../../core/BackButton/BackButton";
import Spinner from "../../core/Spinner/Spinner";

import TableBooleanFilter from "../../core/TableBooleanFilter/TableBooleanFilter";
import TableTextFilter from "../../core/TableTextFilter/TableTextFilter";

import { sessionGetItem, sessionSetItem } from "../../helpers/storage";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

import ILicenseKeySearchResult from "../../types/ILicenseKeySearchResults";

import LicenseKeyRow from "./LicenseKeyRow";

interface ILicenseKeyListProps extends ITranslationProps {
    loading: boolean;
    records: ILicenseKeySearchResult[];
    search: () => void;
}

interface ILicenseKeyListState {
    keyName: string;
    licenseKey: string;
    isActive: boolean;
}

class LicenseKeyList extends React.Component<ILicenseKeyListProps, ILicenseKeyListState> {

    private stateStorageKey = "licenseKeyList_state_storage";

    constructor(props: ILicenseKeyListProps) {
        super(props);

        this.state = { 
            keyName: "",
            licenseKey: "",
            isActive: true
        };

        this.updateKeyName = this.updateKeyName.bind(this);
        this.updateLicenseKey = this.updateLicenseKey.bind(this);
        this.onActiveFilterChange = this.onActiveFilterChange.bind(this);
        this.search = this.search.bind(this);
        this.doesRecordMatchSearchCriteria = this.doesRecordMatchSearchCriteria.bind(this);
    }

    public componentDidMount() {
        const savedState = sessionGetItem<ILicenseKeyListState>(this.stateStorageKey);
        if (savedState) {
            this.setState(savedState, () => {
                this.props.search();
            });
        } else {
            this.props.search();
        }
    }

    public componentWillUnmount() {
        sessionSetItem(this.stateStorageKey, this.state);
    }
    
    public render() {

        const userRows: React.ReactNode[] = [];

        this.props.records.forEach(record => {
            if (this.doesRecordMatchSearchCriteria(record)) {
                userRows.push(<LicenseKeyRow key={record.id} {...record} />);
            }
        });

        return (
            <div>
                {this.props.loading && <Spinner />}

                <BackButton />
                <div>
                    <h2 className="float-left">{this.props.t("LicenseKeyList.Title")}</h2>
                    <Link className="btn btn-primary float-right" to="/licenseKey">{this.props.t("LicenseKeyList.CreateNewLicenseKey")}</Link>
                </div>

                <table className="table table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th>
                                <div>{this.props.t("LicenseKeyList.KeyName")}</div>
                                <TableTextFilter onChange={this.updateKeyName} searchButtonClick={this.search} value={this.state.keyName} />
                            </th>
                            <th>
                                <div>{this.props.t("LicenseKeyList.LicenseKey")}</div>
                                <TableTextFilter onChange={this.updateLicenseKey} searchButtonClick={this.search} value={this.state.licenseKey} />
                            </th>
                            <th>
                                <div>{this.props.t("LicenseKeyList.IsActiveLabel")}</div>
                                <TableBooleanFilter value={this.state.isActive} trueLabel={this.props.t("Global.Active")} falseLabel={this.props.t("Global.Inactive")} onChange={this.onActiveFilterChange} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {userRows}
                    </tbody>
                </table>
            </div>
        );
    }

    private updateKeyName(value: string) {
        this.setState({ keyName: value });
    }

    private updateLicenseKey(value: string) {
        this.setState({ licenseKey: value });
    }

    private onActiveFilterChange(value: boolean): void {
        this.setState({ isActive: value });
    }

    private search() {
        // nothing to do
    }

    private doesRecordMatchSearchCriteria(record: ILicenseKeySearchResult) {
        let matchesSearch = true;
        if (this.state.keyName != null && this.state.keyName !== "") {
            if (record.keyName.toLowerCase().indexOf(this.state.keyName.toLowerCase(), 0) < 0) {
                matchesSearch = false;
            }
        }

        if (this.state.licenseKey != null && this.state.licenseKey !== "") {
            if (record.licenseKey.toLowerCase().indexOf(this.state.licenseKey.toLowerCase(), 0) < 0) {
                matchesSearch = false;
            }
        }

        if (this.state.isActive !== record.isActive) {
            matchesSearch = false;
        }
    
        return matchesSearch;
    }
}

export default translateComponent(LicenseKeyList);



// WEBPACK FOOTER //
// ./src/components/LicenseKeyList/LicenseKeyList.tsx